module.exports = __webpack_public_path__ + "img/login02b.76abbb35.png";